import PropTypes from 'prop-types'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-news`

export const newsItemShape = PropTypes.shape({
  comments: PropTypes.shape({
    count: PropTypes.number,
    url: PropTypes.string
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  img: PropTypes.string,
  tag: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string
  }),
  title: PropTypes.string,
  url: PropTypes.string
})
